import { BuildAction } from "../../../state/power_plants/interface"
import { DataSeriesOverTime } from "../../data/interface"
import { AggregatedBuiltPowerPlantsByH3R4Id } from "../../data/power_plants/interface"
import { AllCapacityFactorData } from "../../data/wind_and_solar_capacity/load_data"
import { ValueByPowerStorageType, ValueByPowerType, ValueByStorageType } from "../interface"


export const STORAGE_TYPES = [
    "battery",
    "hydro_pumped_storage",
] as const
export const POWER_TYPES = [
    "wind",
    "solar",
    "gas",
    "nuclear",
    "hydro_river",
    ...STORAGE_TYPES,
] as const
// export type StorageType = (typeof STORAGE_TYPES)[number]
export type PowerType = (typeof POWER_TYPES)[number]
// export type ValueByStorageType<V> = Record<StorageType, V>
// export type ValueByPowerType<V> = Record<PowerType, V>
// export type ValueByPowerStorageType<VPower, VStore> = Record<PowerType, VPower> & Record<StorageType, VStore>


export interface ModelDataInputs
{
    demand_GW_by_hour: DataSeriesOverTime<number>
    capacity_factor_data: AllCapacityFactorData
    initial_aggregated_power_plants_by_h3r4_id: AggregatedBuiltPowerPlantsByH3R4Id
    initial_proportional_electricity_demand_GW_by_h3r4: Record<string, number>
}

export interface SimulationConfig
{
    start_datetime: Date
    /**
     * Inclusive end datetime for the simulation.  For example if the simulation
     * is over one day and starts at 2022-01-15 00:00 then the end_datetime will
     * be 2022-01-15 23:00
     */
    end_datetime: Date
}



export interface IGameScore
{
    building_cost: number
    shortage_TWh: number
    excess_TWh: number
    running_cost: number
    resilience_score: number
    total_score: number
}

export interface SimulationState extends InitialAndFinalState
{
    config: SimulationConfig & {
        start_timestamp_index: number
        end_timestamp_index: number
    }

    score: IGameScore

    timesteps: StateAtTimepoint[]
}

interface InitialAndFinalState
{
    demand_GW_proportion_by_h3r4:
    {
        initial: Record<string, number>
    }
    built_power_plants:
    {
        // We can add intermediate timepoints where a user decides to build a
        // new power plant part way through the simulation as opposed to right
        // at the start.  Or perhaps if there's some event that disables or
        // destroys a power plant part way through the simulation.  For now we
        // just log the initial and the final state of the power plants
        // initial: AggregatedBuiltPowerPlantsByH3R4Id
        aggregated_by_h3r4: AggregatedBuiltPowerPlantsByH3R4Id
        capacity_GW_by_type: ValueByPowerType<number>
        storage_GWh_by_type: ValueByStorageType<number>
    }
}

export interface StateAtTimepoint
{
    timestamp_ms: number
    // TODO if we include this then document what index it is: the hourly index
    // for that year, for the index for that simulation's time range, or something
    // else.
    // timestamp_index: number

    // demand_GW should be derived from by_h3r4.demand_GW but for now it's
    // calculated by ascribing demand proportional to each h3r4 cell.
    demand_GW: number
    by_h3r4: SimStateByH3R4Id

    generated_GW_by_type: ValueByPowerType<number>
    stored_GWh_by_type: ValueByStorageType<number>

    generated_GW:
    {
        primary: number
        /**
         * storage can be negative if used to store energy.
         */
        storage: number
        total_positive: number
    }

    /** i.e. power which would be curtailed due to grid constraints */
    excess_GW: number
    /**
     * Power which won at auction and would have delivered onto the grid but had
     * to be requested by NESO to not deliver due to national pricing and grid
     * constraints.
     */
    flipflop_GW: number
}


export type SimStateByH3R4Id = Record<string, {
    demand_GW?: number
    power_plants?: PowerPlantStatusesForH3R4
}>

interface MWGenCap {
    generated_MW: number
}
interface MWhStore {
    stored_MWh: number
}
export type PowerPlantStatusesForH3R4 = {
    total_generated_MW: {
        primary: number
        storage: number
        total_positive: number
    }
} & ValueByPowerStorageType<MWGenCap, MWhStore>


// interface UserBuildAction
// {
//     h3r4_id: string
//     power_type: PowerType
//     set_area_km2: number
// }

export type UserAction = BuildAction
